import AscButton from "../../AscButton/AscButton";
import classNames from "classnames";
import styles from "./AscAddModuleFooter.module.scss";

export interface AscAddModuleFooterProps {
  className?: string;
  currentValue?: number;
  goNext?: () => void;
  goBack?: () => void;
  disabled?: boolean;
  touched?: boolean;
}

export default function AscAddModuleFooter({
  className,
  currentValue,
  goNext,
  goBack,
  disabled = false,
  touched = true,
}: AscAddModuleFooterProps) {
  return (
    <div
      className={classNames(
        styles.ground,
        currentValue === 1 && styles.oneButton,
        className
      )}
    >
      {currentValue !== 1 && (
        <AscButton
          onClick={goBack}
          className={styles.button}
          variant="secondary"
        >
          Back
        </AscButton>
      )}
      <AscButton
        disabled={disabled}
        type="submit"
        onClick={goNext}
        className={classNames(styles.button)}
      >
        {touched ? "Save &" : null} Continue
      </AscButton>
    </div>
  );
}
